// Default content — user-facing copy/media fall back to these values if the
// admin has not yet overridden them via the /admin editor.
export const DEFAULT_CONTENT = {
  site: {
    name: "TREVOR",
    tagline: "The man, off camera.",
    location: "Los Angeles · Available Selectively",
    years: "MMXXVI",
  },
  hero: {
    // image OR video — if video is a non-empty URL it wins.
    image: "https://images.pexels.com/photos/30743727/pexels-photo-30743727.jpeg",
    video: "",
    currentlyLabel: "CURRENTLY",
    currentlyBody: "Accepting three reservations for the winter.",
    subhead:
      "Four disciplines. One late-night hour. A dossier assembled in low light, updated only when he agrees to sit still.",
    lines: ["He pours", "before he speaks.", "He listens", "before he pours."],
  },
  manifestoIntro: [
    "This is a dossier, not a résumé.",
    "Four things he does with his hands.",
    "One thing he does with his mouth: listen.",
  ],
  chapters: [
    {
      id: "dating",
      number: "01",
      title: "Dating",
      kicker: "Candlelight & Consequence",
      image: "https://images.pexels.com/photos/19269784/pexels-photo-19269784.jpeg",
      video: "",
      copy: [
        "A slow dinner is a conversation with a beginning, a middle, and a decision. Trevor does not chase; he sets the table.",
        "Reserve a night. He'll choose the room. You choose what stays and what leaves with the wine.",
      ],
      tags: ["Reservations", "Private Table", "No Phones"],
    },
    {
      id: "bartending",
      number: "02",
      title: "Bartending",
      kicker: "The Long Pour",
      image: "https://images.pexels.com/photos/6475039/pexels-photo-6475039.jpeg",
      video: "",
      copy: [
        "Twelve years behind mahogany. He remembers your drink and the story you told him the third time you ordered it.",
        "Private events. Rye-forward. Ice cut by hand. No umbrella drinks. No apologies.",
      ],
      tags: ["Rye", "Amaro", "Off-Menu"],
    },
    {
      id: "knowledge",
      number: "03",
      title: "General Knowledge",
      kicker: "Marginalia",
      image: "https://images.pexels.com/photos/27236661/pexels-photo-27236661.jpeg",
      video: "",
      copy: [
        "He reads the way other men drink. Cormac McCarthy on a Tuesday, Joan Didion on a Sunday, tax code when the mood is grim.",
        "Ask him anything. He may not know, but he will find out before you finish your glass.",
      ],
      tags: ["Literature", "Cinema", "History"],
    },
    {
      id: "therapy",
      number: "04",
      title: "Physical Therapy",
      kicker: "Hands That Remember",
      image: "https://images.pexels.com/photos/29807420/pexels-photo-29807420.jpeg",
      video: "",
      copy: [
        "DPT credentialed. Fifteen years fixing what athletes broke and desk jobs quietly ruined.",
        "Sessions are honest. The work is not gentle. The results outlast the invoice.",
      ],
      tags: ["Manual Therapy", "Recovery", "Post-Op"],
    },
  ],
  marquee: [
    "Dating",
    "Bartending",
    "General Knowledge",
    "Physical Therapy",
    "Dating",
    "Bartending",
    "General Knowledge",
    "Physical Therapy",
  ],
  timeSlots: ["18:00", "19:00", "20:00", "21:00", "22:00"],
};
